import styled from 'styled-components';

const UnorderedList = styled.ul`
  margin-bottom: 2rem;
`;

export default UnorderedList;
